export const ORDER_TYPE: { ASCENDING: 'asc'; DESCENDING: 'desc' } = {
  ASCENDING: 'asc',
  DESCENDING: 'desc',
};

export default ORDER_TYPE;
